import React, {useEffect, useState, useRef, use} from 'react'
import { getGenres } from '../../actions/filterActions'
import { useDispatch, useSelector } from 'react-redux'
import FilterComponent from './FilterComponent';
import AdminFilterComponent from '../../adminContent/AdminVideos/AdminFilterComponent';

const Genres = (props) => {

    const dispatch = useDispatch()

    const {error, loading, genres} = useSelector(state => state.genres)

    const [genreActive, setGenreActive] = useState(false)

    const [genreValue, setGenreValue] = useState('')

    const [genreList, setGenreList] = useState(genres)

    const searchGenreRef = useRef()

    useEffect(()=>{
 
        dispatch(getGenres(props.filterList))
    
      },[props.filterList])


    useEffect(()=>{
        document.addEventListener("mousedown", (event) => {
            if (searchGenreRef == null || searchGenreRef.current == null || !searchGenreRef.current.contains(event.target)){
                setGenreActive(false)
            }
        })
    }) 

    useEffect(()=>{
        setGenreList(genres)
    },[genres])

    useEffect(()=>{
        
        let g = genreList.filter(genre =>
            genre.title.toLowerCase().startsWith(genreValue?.toLowerCase() || ""))
        if(genreValue === ''){
            g = genres
        }
        setGenreList(g)
    },[genreValue])


    const chooseHandler = (genre) => {
        if (props.filterList.filter(g => g[0] === genre.id && g[2] === 1 ).length === 0 ){
            props.setFilterList((prevArr)=>{ return[...prevArr, [genre.id, genre.title, 1]]})
        }
        setGenreActive(false)
        setGenreValue('')
    }


    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            if (genres && genres.length){
                if (props.filterList.filter(g => g[0] === genres[0].id && g[2] === 1 ).length === 0 ){
                    props.setFilterList((prevArr)=>{ return[...prevArr, [genres[0].id, genres[0].title, 1]]})
                }
                setGenreActive(false)
                setGenreValue('')
            }
        }
    }


    return (
        <>
            {
                props.index === 1 ? 
                <AdminFilterComponent
                    data = {genres}
                    setValue = {setGenreValue}
                    setActive = {setGenreActive}
                    value = {genreValue}
                    isActive = {genreActive}
                    chooseHandler = {chooseHandler}
                    componentRef = {searchGenreRef}
                    title = "Genres"
                    loading = {loading}
                /> :
                <FilterComponent
                    data = {genreList}
                    setValue = {setGenreValue}
                    setActive = {setGenreActive}
                    value = {genreValue}
                    isActive = {genreActive}
                    chooseHandler = {chooseHandler}
                    componentRef = {searchGenreRef}
                    title = "Genres"
                    loading = {loading}
                    handleKeyDown = {handleKeyDown}
            />
            }
        </>
    );
};

export default Genres;